(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-back-to-top"] && !Shopify.designMode) return;
  try {
    const mobileBackToTop = document.getElementById('MobileBackToTop');

  if (mobileBackToTop) {
    let mobileBackToTopTicking = false;

    const updateMobileBackToTop = () => {
      mobileBackToTop.hidden = !(window.innerWidth < 750 && window.scrollY > 320);
    };

    const requestMobileBackToTopUpdate = () => {
      if (!mobileBackToTopTicking) {
        window.requestAnimationFrame(() => {
          updateMobileBackToTop();
          mobileBackToTopTicking = false;
        });
        mobileBackToTopTicking = true;
      }
    };

    mobileBackToTop.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    });

    window.addEventListener('scroll', requestMobileBackToTopUpdate, { passive: true });
    window.addEventListener('resize', requestMobileBackToTopUpdate);
    updateMobileBackToTop();
  }
  } catch(e) { console.error(e); }
})();

})();
